module.exports = __webpack_public_path__ + "static/media/kid.dc17be55.png";